import type { Story } from '../lib/story';
import { BrandMark } from './BrandMark';

export default {
  kind: 'component',
  title: { pl: 'Znak marki', en: 'Brand mark' },
  description: {
    pl: 'Logo ITLamb — te same kwadraty co `public/favicon.svg`, wstawione w kod, żeby kolory brały się z motywu. Dekoracyjne: nazwę niesie link wokół niego.',
    en: 'The ITLamb logo — the same squares as `public/favicon.svg`, inline so its colours come from the theme. Decorative: the link around it carries the name.',
  },
  variants: [
    {
      name: { pl: 'Znak', en: 'Mark' },
      render: () => <BrandMark />,
    },
  ],
} satisfies Story;
